import React, { useEffect, useState } from "react";
import classes from "./HomePageFilter.module.css";
import ModalSkeletonClasses from "../../../ModalSkeleton/ModalSkeleton.module.css";
import { Row, Col } from "react-bootstrap";
import Fonts from "../../../../stories/assets/Fonts";
import {
  CancelIconBlack,
  LocationIconBlack,
} from "../../../../constant/imagePath";
import Colors from "../../../../stories/assets/Colors";
import { Input } from "../../../../stories/Input/Input";
import { ReactSVG } from "react-svg";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { InputWithSearchIcon } from "../../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { Button } from "../../../../stories/Button/Button";
import MonthSmallCalander from "../../../../components/MonthSmallCalander";
import Maps from "../../../Maps";
import { DoubleCalander } from "../../../../stories/DoubleCalander/DoubleCalander";

const HomePageFilter = ({ show, setShow, playcard, getSearchDataHandler }) => {
  const [searchType, setSearchType] = useState("sports");
  const [sports, setSports] = useState("");
  const [location, setLocation] = useState("");
  const [date, setDate] = useState();

  const [searchObj, setSearchObj] = useState({});

  const [coordinate, setCoordinate] = useState({});

  const setValue = (item) => {
    const newObject = { ...searchObj };
    newObject[searchType] = item;
    setSearchObj(newObject);
    setSearchType(
      searchType == "sports"
        ? "location"
        : searchType == "location"
          ? "date"
          : "sports"
    );
  };

  return (
    <>
      <style>{`
      .${ModalSkeletonClasses.body} {
        padding: 0px;
      }
          .modal .modal-dialog {
            width: 100% !important;
            margin: 0px !important;
            max-width: 100% !important;
            height: 100%;
          }
          
        .modal-content{
            min-height:100%;
            border:none;

        }
        .modal { 
            border-radius: 0px;
            background: white;
            border:none;

          }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"0px"}
        width={"100%"}
      >
        <div
          className={[classes.FilterHeader].join(" ")}
          style={{
            borderBottom:
              searchType === "date" &&
              `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        >
          <ReactSVG
            src={CancelIconBlack}
            onClick={() => {
              setSearchType("sports");
              setShow(false);
            }}
          />

          <h6
            style={{
              ...Fonts.b3,
              color: Colors.neutralShadesOfNero,
            }}
          >
            Search
          </h6>
          <div />
        </div>
        {searchType === "sports" && (
          <div className={[classes.middleContent]}>
            <div className={[classes.SearchDiv]}>
              <InputWithSearchIcon
                placeholder="Sport type, technique, coach..."
                state={sports}
                setter={setSports}
              />
            </div>
            {playcard?.filter((item, i) =>
              item.title.toLowerCase().includes(sports.toLowerCase())
            ).length > 0 ? (
              playcard
                ?.filter((item, i) =>
                  item.title.toLowerCase().includes(sports.toLowerCase())
                )
                .map((item, i) => {
                  return (
                    <div
                      className={[classes.sportsDiv]}
                      key={i}
                      onClick={() => setValue(item?.title)}
                    >
                      <p
                        style={{
                          color: Colors.neutralShadesOfNero,
                          ...Fonts.b3,
                        }}
                      >
                        {item?.title}
                      </p>
                      <p
                        style={{
                          color: Colors.neutralShadesOfDimGray,
                          ...Fonts.b1Mobile,
                        }}
                      >
                        {item?.value}
                      </p>
                    </div>
                  );
                })
            ) : (
              <p
                style={{ color: Colors.neutralShadesOfNero, ...Fonts.b3 }}
                className={[classes.NoData]}
              >
                No Sports Found
              </p>
            )}
          </div>
        )}

        {searchType === "location" && (
          <>
            <div className={[classes.middleContent]}>
              <div className={[classes.SearchDiv]}>
                <Maps
                  type={"places"}
                  label={""}
                  setAddress={setLocation}
                  placeholder={"Location"}
                  setCoordinates={setCoordinate}
                />
              </div>
            </div>
            <div
              className={classes.footerBtns}
              style={{
                borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
            >
              <Button
                label={"Skip"}
                primary={false}
                size={"Large"}
                customStyle={{
                  width: "95px",
                  backgroundColor: Colors.white,
                  border: "none",
                  ...Fonts.b2,
                  lineHeight: "20px",
                }}
                onClick={() => setSearchType("date")}
              />
              <Button
                label={"Next"}
                primary={true}
                size={"Large"}
                customStyle={{
                  width: "120px",
                  height: "48px",
                  ...Fonts.b2,
                  lineHeight: "20px",
                }}
                onClick={() =>
                  setValue({
                    address: location,
                    lat: coordinate.lat,
                    lng: coordinate.lng,
                  })
                }
              />
            </div>
          </>
        )}

        {searchType === "date" && (
          <>
            <div className={[classes.middleContent]}>
              <DoubleCalander value={date} setValue={setDate} />
              {/* <MonthSmallCalander value={date} setValue={setDate} /> */}
            </div>
            <div
              className={classes.footerBtns}
              style={{
                borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
            >
              <Button
                label={"Skip"}
                primary={false}
                size={"Large"}
                customStyle={{
                  width: "95px",
                  backgroundColor: Colors.white,
                  border: "none",
                  ...Fonts.b2,
                  lineHeight: "20px",
                }}
                onClick={() => {
                  getSearchDataHandler({ ...searchObj });
                  setShow(false);
                }}
              />
              <Button
                label={"Search"}
                primary={true}
                size={"Large"}
                customStyle={{
                  width: "120px",
                  height: "48px",
                  ...Fonts.b2,
                  lineHeight: "20px",
                }}
                onClick={() => {
                  getSearchDataHandler({ ...searchObj, date });
                  setShow(false);
                }}
              />
            </div>
          </>
        )}
      </ModalSkeleton>
    </>
  );
};

export default HomePageFilter;
